<section class="pc-card" *ngIf="possuiPrecoDiferenciado || erro" aria-labelledby="precos-canais-titulo">
  <header>
    <h3 id="precos-canais-titulo">Preços por canal</h3>
    <p>Somente canais com preço específico ou percentual aparecem aqui. Os demais acompanham o preço do Promokit.
      <span *ngIf="temModuloTabelaPrecos">As tabelas de preços ativas também aparecem nesta grade.</span>
    </p>
  </header>
  <p *ngIf="!produtoId">Salve o produto primeiro para configurar os preços por canal.</p>
  <p *ngIf="carregando" role="status"><span class="fa fa-spinner fa-spin"></span> Carregando canais…</p>
  <div class="pc-error" *ngIf="erro" role="alert">
    {{ erro }}
    <button type="button" *ngIf="!linhas.length && produtoId" (click)="carregue()">Tentar novamente</button>
  </div>
  <ng-container *ngIf="produtoId">
    <p *ngIf="canaisHabilitados && !carregando && !erro && !linhas.length">Nenhum marketplace cadastrado para este catálogo.
      <a routerLink="/admin/canais-venda/publicar-produtos">Cadastrar canal de venda</a>
    </p>
    <ng-container>
      <app-produto-tabela-precos *ngIf="temModuloTabelaPrecos; else apenasCanais"
        [empresa]="empresa" [produto]="produto" [produtoId]="produtoId"
        [targetSelecionadoKeyPreferencial]="tabelaPrecosTargetKey"
        [podeEditarPrecos]="podeEditar" [templatePrecos]="gradePrecos">
      </app-produto-tabela-precos>
      <ng-template #apenasCanais><ng-container *ngTemplateOutlet="gradePrecos"></ng-container></ng-template>
      <ng-template #gradePrecos let-tabelas>
      <div class="pc-tools" *ngIf="podeEditar && linhas.length">
        <label>Repassar nos marketplaces
          <span class="pc-percent"><input type="number" min="-100" max="1000" step="0.5" [(ngModel)]="percentual"
            [ngModelOptions]="{standalone: true}" [disabled]="ocupado(tabelas)" aria-label="Acréscimo percentual"> %</span>
        </label>
        <span class="pc-action">
          <button type="button" [disabled]="ocupado(tabelas)" (click)="apliquePrecos(false)">Aplicar</button>
          <span kendoPopoverAnchor [popover]="ajudaAplicar" showOn="click">
            <button type="button" class="pc-info" aria-label="Entenda a ação Aplicar">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </button>
          </span>
          <kendo-popover #ajudaAplicar [width]="300" position="bottom">
            <ng-template kendoPopoverTitleTemplate>Aplicar</ng-template>
            <ng-template kendoPopoverBodyTemplate>Define preços específicos nos marketplaces usando o percentual informado.</ng-template>
          </kendo-popover>
        </span>
        <span class="pc-action" *ngIf="podeUsarRegraDoCanal">
          <button type="button" [disabled]="ocupado(tabelas)" (click)="apliquePrecos(true)">Usar regra do canal</button>
          <span kendoPopoverAnchor [popover]="ajudaRegraCanal" showOn="click">
            <button type="button" class="pc-info" aria-label="Entenda a regra de preço do canal">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </button>
          </span>
          <kendo-popover #ajudaRegraCanal [width]="300" position="bottom">
            <ng-template kendoPopoverTitleTemplate>Usar regra do canal</ng-template>
            <ng-template kendoPopoverBodyTemplate>Acompanha automaticamente o preço e a promoção do Promokit, com o percentual configurado no canal.</ng-template>
          </kendo-popover>
        </span>
      </div>
      <div class="pc-table-wrap">
        <table>
          <thead><tr><th>Canal</th><th>Disponibilidade</th><th>Preço</th>
            <ng-container *ngIf="exibirColunasPromocao || tabelas?.linhas.length"><th>Desconto</th><th>Preço total</th></ng-container>
            <ng-container *ngIf="tabelas?.exibeColunasAtacado"><th>{{ tabelas.rotuloPrecoAtacado }}</th><th>{{ tabelas.rotuloQuantidadeMinima }}</th></ng-container>
          </tr></thead>
          <tbody>
            <tr class="pc-local" [class.pc-inactive]="!disponivelCardapio">
              <td>
                <div class="pc-channel">
                  <img class="pc-logo" src="https://meucardapio.ai/favicon.ico" alt="MeuCardápio">
                  <div><strong>MeuCardápio</strong><small>Cardápio digital de referência</small></div>
                </div>
                <button type="button" class="pc-promotion-button"
                  *ngIf="editarMeuCardapio && podeEditar"
                  [disabled]="ocupado(tabelas)"
                  (click)="promocaoCardapioAtivaChange.emit(!promocaoCardapioAtiva)">
                  {{ promocaoCardapioAtiva ? 'Desativar promoção' : 'Ativar promoção' }}
                </button>
              </td>
              <td>
                <label class="pc-switch" [attr.title]="disponivelCardapio ? 'Disponível' : 'Indisponível'">
                  <input type="checkbox" [checked]="disponivelCardapio" disabled
                    [attr.aria-label]="disponivelCardapio ? 'Disponível' : 'Indisponível'">
                  <span aria-hidden="true"></span>
                </label>
              </td>
              <td>
                <label class="pc-money"><span aria-hidden="true">R$</span>
                  <input type="number" min="0" step="0.01" [ngModel]="precoCardapio"
                    [ngModelOptions]="{standalone: true}" (ngModelChange)="precoCardapioChange.emit($event)"
                    [disabled]="!podeEditar || !editarMeuCardapio || ocupado(tabelas)"
                    aria-label="Preço no MeuCardápio">
                </label>
              </td>
              <ng-container *ngIf="exibirColunasPromocao || tabelas?.linhas.length">
                <td>
                  <label class="pc-money pc-money--discount" *ngIf="promocaoCardapioAtiva; else semPromocaoCardapio">
                    <span aria-hidden="true">R$</span>
                    <input type="number" min="0" step="0.01" [ngModel]="descontoCardapio"
                      [ngModelOptions]="{standalone: true}" (ngModelChange)="descontoCardapioChange.emit($event)"
                      [disabled]="!podeEditar || !editarMeuCardapio || ocupado(tabelas)"
                      aria-label="Desconto no MeuCardápio">
                  </label>
                  <ng-template #semPromocaoCardapio>—</ng-template>
                </td>
                <td class="pc-final"><strong>{{ precoFinalCardapio == null ? '—' : (precoFinalCardapio | currency:'BRL':'symbol':'1.2-2':'pt') }}</strong></td>
              </ng-container>
              <ng-container *ngIf="tabelas?.exibeColunasAtacado" [ngTemplateOutlet]="atacadoIndisponivel"></ng-container>
            </tr>
            <tr *ngFor="let linha of tabelas?.linhasExibidas; trackBy: tabelas?.trackByLinha" class="pc-price-table"
              [class.pc-inactive]="!linha.tabela.ativo">
              <td>
                <div class="pc-channel">
                  <span class="pc-logo pc-table-icon fa fa-tags" aria-hidden="true"></span>
                  <div><strong>{{ linha.tabela.nome }}</strong><small>Tabela de preços · {{ tabelas.canalLabel(linha.tabela.canal) }}</small></div>
                </div>
                <small *ngIf="tabelas.ehProdutoPizzaComTamanhos">{{ tabelas.targetSelecionado?.nome }}</small>
                <small *ngIf="linha.dirty">Alteração não salva</small>
                <small class="pc-error" *ngIf="linha.dirty && tabelas.linhaPrecoInvalida(linha)">Informe um preço válido.</small>
                <small class="pc-error" *ngIf="linha.dirty && tabelas.linhaDescontoInvalida(linha)">O desconto deve estar entre zero e o preço.</small>
                <small class="pc-error" *ngIf="linha.dirty && tabelas.linhaPrecoAtacadoInvalido(linha)">O atacado deve ser menor que o preço de varejo.</small>
                <small class="pc-error" *ngIf="linha.dirty && tabelas.linhaAtacadoInvalida(linha)">A quantidade mínima deve ser maior que 1.</small>
              </td>
              <td><span title="A disponibilidade segue as regras da tabela de preços.">Conforme a tabela</span></td>
              <td>
                <label class="pc-money"><span aria-hidden="true">R$</span>
                  <input type="number" min="0" step="0.01" [(ngModel)]="linha.item.valor"
                    [ngModelOptions]="{standalone: true}" (ngModelChange)="tabelas.marqueAlterada(linha)"
                    [disabled]="!podeEditar || ocupado(tabelas)" [attr.aria-label]="tabelas.rotuloPrecoPrincipal + ' em ' + linha.tabela.nome">
                  <span *ngIf="tabelas.sufixoPrecoTabela">{{ tabelas.sufixoPrecoTabela }}</span>
                </label>
              </td>
              <ng-container *ngIf="exibirColunasPromocao || tabelas?.linhas.length">
                <td>
                  <label class="pc-money pc-money--discount"><span aria-hidden="true">R$</span>
                    <input type="number" min="0" step="0.01" [(ngModel)]="linha.item.desconto"
                      [ngModelOptions]="{standalone: true}" (ngModelChange)="tabelas.marqueAlterada(linha)"
                      [disabled]="!podeEditar || ocupado(tabelas)" [attr.aria-label]="tabelas.rotuloDesconto + ' em ' + linha.tabela.nome">
                  </label>
                </td>
                <td class="pc-final"><strong>{{ linha.item.valor == null ? '—' : (tabelas.obtenhaPrecoFinal(linha) | currency:'BRL':'symbol':'1.2-2':'pt') }}</strong></td>
              </ng-container>
              <ng-container *ngIf="tabelas?.exibeColunasAtacado">
                <td>
                  <label class="pc-money"><span aria-hidden="true">R$</span>
                    <input type="number" min="0" step="0.01" [(ngModel)]="linha.item.valorAtacado"
                      [ngModelOptions]="{standalone: true}" (ngModelChange)="tabelas.marqueAlterada(linha)"
                      [disabled]="!podeEditar || ocupado(tabelas) || !linha.tabela.suportaPrecosAtacado"
                      [attr.aria-label]="tabelas.rotuloPrecoAtacado + ' em ' + linha.tabela.nome">
                  </label>
                </td>
                <td>
                  <input type="number" min="2" step="1" [(ngModel)]="linha.item.quantidadeMinimaAtacado"
                    [ngModelOptions]="{standalone: true}" (ngModelChange)="tabelas.marqueAlterada(linha)"
                    [disabled]="!podeEditar || ocupado(tabelas) || !linha.tabela.suportaPrecosAtacado"
                    [attr.aria-label]="tabelas.rotuloQuantidadeMinima + ' em ' + linha.tabela.nome">
                </td>
              </ng-container>
            </tr>
            <tr *ngFor="let linha of linhasExibidas" [class.pc-inactive]="!linha.disponivel || !linha.canal.ativo">
              <td>
                <div class="pc-channel">
                  <img *ngIf="logoCanal(linha.canal.plataforma) as logo" class="pc-logo" [src]="logo"
                    [alt]="linha.canal.plataforma === 'IFOOD' ? 'iFood' : '99Food'">
                  <div><strong>{{ linha.canal.nome }}</strong>
                    <small>{{ linha.canal.ativo ? 'Marketplace' : 'Canal inativo' }}</small></div>
                </div>
                <small *ngIf="linha.canal.plataforma !== 'IFOOD' && linha.canal.plataforma !== 'FOOD99'">Edição ainda indisponível para esta plataforma.</small>
                <small *ngIf="linha.produto.vinculo === 'SEM_VINCULO'">Novo no canal</small>
                <small *ngIf="linha.mensagem" [class.pc-error]="linha.erro" class="pc-result" role="status">{{ linha.mensagem }}</small>
                <small *ngIf="linha.alterado && !linha.mensagem">Alteração não salva</small>
                <button type="button" class="pc-promotion-button" *ngIf="editavel(linha, tabelas)"
                  [disabled]="ocupado(tabelas)"
                  (click)="alterePromocaoCanal(linha, !linha.promocaoAtiva)">
                  {{ linha.promocaoAtiva ? 'Desativar promoção' : 'Ativar promoção' }}
                </button>
              </td>
              <td>
                <label class="pc-switch" [attr.title]="linha.disponivel ? 'Disponível' : 'Pausado'">
                  <input type="checkbox" [ngModel]="linha.disponivel" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="altereDisponibilidade(linha, $event)"
                    [disabled]="!editavel(linha, tabelas)"
                    [attr.aria-label]="(linha.disponivel ? 'Disponível em ' : 'Pausado em ') + linha.canal.nome">
                  <span aria-hidden="true"></span>
                </label>
              </td>
              <td>
                <label class="pc-money"><span aria-hidden="true">R$</span>
                  <input type="number" min="0" step="0.01" [ngModel]="valorCanal(linha)" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="alterePreco(linha, $event)" [disabled]="!editavel(linha, tabelas)"
                    [attr.aria-label]="'Preço em ' + linha.canal.nome">
                </label>
              </td>
              <ng-container *ngIf="exibirColunasPromocao || tabelas?.linhas.length">
                <td>
                  <label class="pc-money pc-money--discount" *ngIf="linha.promocaoAtiva; else semPromocaoCanal">
                    <span aria-hidden="true">R$</span>
                    <input type="number" min="0" step="0.01" [ngModel]="linha.herdar ? 0 : linha.desconto"
                      [ngModelOptions]="{standalone: true}" (ngModelChange)="altereDesconto(linha, $event)"
                      [disabled]="!editavel(linha, tabelas)" [attr.aria-label]="'Desconto em ' + linha.canal.nome">
                  </label>
                  <ng-template #semPromocaoCanal>—</ng-template>
                </td>
                <td class="pc-final"><strong>{{ precoFinal(linha) == null ? '—' : (precoFinal(linha) | currency:'BRL':'symbol':'1.2-2':'pt') }}</strong>
                  <small class="pc-price-increase" *ngIf="percentualMaisCaro(linha) as aumento">+{{ aumento | number:'1.0-1':'pt' }}%</small>
                  <small>Antes das taxas</small>
                </td>
              </ng-container>
              <ng-container *ngIf="tabelas?.exibeColunasAtacado" [ngTemplateOutlet]="atacadoIndisponivel"></ng-container>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="pc-notice" *ngIf="linhas.length">Os preços dos marketplaces são salvos sem publicar.
        Depois, revise e envie em <a routerLink="/admin/canais-venda/alteracoes">Publicações</a>.</p>
      <footer *ngIf="podeEditar && linhas.length">
        <span>{{ quantidadePendentes(tabelas) }} linha(s) com alterações não salvas</span>
        <button type="button" class="pc-primary" [disabled]="ocupado(tabelas) || !quantidadePendentes(tabelas)" (click)="salve(tabelas)">
          <i class="fa fa-spinner fa-spin" *ngIf="salvando" aria-hidden="true"></i>
          {{ salvando ? 'Salvando…' : 'Salvar preços' }}
        </button>
      </footer>
      </ng-template>
      <ng-template #atacadoIndisponivel>
        <td><input type="number" disabled placeholder="—" aria-label="Preço atacado indisponível neste canal" title="Este canal não utiliza preço de atacado."></td>
        <td><input type="number" disabled placeholder="—" aria-label="Quantidade de atacado indisponível neste canal" title="Este canal não utiliza preço de atacado."></td>
      </ng-template>
    </ng-container>
  </ng-container>
</section>
